//
//
//
//
//
//
//
//
//

import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
export default {
  name: 'WeforsysQuill',
  components: {
    quillEditor: quillEditor
  },
  props: {
    prefixCls: {
      type: String,
      default: 'weforsys-editor-quill'
    },
    // 表单校验用字段
    // eslint-disable-next-line
    value: {
      type: String
    },
    placeholder: {
      type: String,
      default: '请输入内容...'
    }
  },
  data: function data() {
    return {
      content: this.value,
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{
            header: [1, 2, 3, 4, 5, 6, false]
          }], [{
            size: ["small", false, "large", "huge"]
          }], [{
            color: []
          }, {
            background: []
          }], ["blockquote", "code-block"], [{
            list: "ordered"
          }, {
            list: "bullet"
          }], [{
            indent: "-1"
          }, {
            indent: "+1"
          }], [{
            align: []
          }], [{
            direction: "rtl"
          }], ["clean"], ["link", "image"]]
        },
        theme: 'snow',
        placeholder: this.placeholder
      }
    };
  },
  methods: {
    onEditorBlur: function onEditorBlur(quill) {
      // console.log('editor blur!', quill)
    },
    onEditorFocus: function onEditorFocus(quill) {
      // console.log('editor focus!', quill)
    },
    onEditorReady: function onEditorReady(quill) {
      // console.log('editor ready!', quill)
    },
    onEditorChange: function onEditorChange(_ref) {
      var quill = _ref.quill,
        html = _ref.html,
        text = _ref.text;
      // console.log('editor change!', quill, html, text)
      // this.$emit('change', html)
      this.$emit("input", this.content);
    }
  },
  computed: {
    editor: function editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  watch: {
    value: function value(val) {
      this.content = val;
    },
    placeholder: function placeholder(val) {
      this.$set(this.editorOption, 'placeholder', val);
    }
  }
};